export const LOGIN_FORM_FIELD_EMAIL = 'email'
export const LOGIN_FORM_FIELD_PASSWORD = 'password'



// WEBPACK FOOTER //
// ./src/constants/LoginFormFieldName.tsx